// extracted by mini-css-extract-plugin
export default {"fab":"ErrorReportRoot_fab__B-tlw","text":"ErrorReportRoot_text__0kosK"};